<template>
  <div class="legacy-subscription">
    <headerComponent></headerComponent>
    <div class="container position-relative mb-5">
      <div class="row">
        <div class="col-lg-4">
          <sidebarComponent @sidebarLoaded = "sidebarLoaded"></sidebarComponent>          
        </div>
        <div class="col-lg-8">
          <div class="table-responsive">
            <table class="table" v-if="legacy">
              <tbody>
                <tr>
                  <td>Status</td>
                  <td v-if="legacy.status==2">Active</td>
                  <td v-else>Cancelled</td>
                </tr>
                <tr>
                  <td>Start date</td>
                  <td>{{ legacy.date_added_formatted }}</td>
                </tr>
                <tr>
                  <td>Next payment date</td>
                  <td>{{ legacy.next_payment_date_formatted }}</td>
                </tr> 
                <tr>
                  <td>Subscription name</td>
                  <td>{{display.name}}</td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>${{legacy.amount}}</td>
                </tr>
                <tr>
                  <td>Profile ID (Legacy)</td>
                  <td>{{legacy.recurring_id}}</td>
                </tr>
              </tbody>
              <!-- <tfoot v-if="this.legacy">
                <tr>
                  <td colspan="2">
                    <button @click="deactivateSubscription()">Deactivate subscription</button>
                  </td>
                </tr>
              </tfoot> -->
            </table>
            <button v-if="legacy && legacy.reference!=='Bank Transfer' && legacy.status==2" @click="deactivateSubscription()">Cancel subscription</button>
            <span v-else><strong>To upgrade or change your plan please contact the 3DViewronline Team</strong></span>

          </div>
          
        </div>
      </div>
    </div>
    <div class="loader" v-if="!load">
      <div>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <footerComponent></footerComponent>
  </div>
</template>
<script>
/* eslint-disable */ 
import sidebarComponent from '../components/Sidebar.vue'
import commonProps from '../common/common.js'
import headerComponent from '../components/Header.vue'
import footerComponent from '../components/Footer.vue'
import axios from 'axios'
import '@/assets/scss/models-list.scss'
import legacyReference from '@/config/legacy/table.json'
const common = new commonProps()
/* eslint-enable */
export default {
  name:'legacy-subscription',
  components: {
    sidebarComponent,
    headerComponent,
    footerComponent
  },
  data() {
    return {
      load:false,
      legacy:null,
      display:{}
    }
  },
  mounted() {

  },
  methods: {
    sidebarLoaded(value) {
      this.load = value;
    },
    deactivateSubscription() {
      this.$swal({
          title:'Are you sure you want to deactivate this subsription?',
          text: "You won't be able to revert this!",
          icon:'warning',
          type:"warning",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: "No"
        }).then(isConfirm => {
          if (isConfirm.isConfirmed)
            {

              axios.get(`${common.supervisorApi}subscriptions/deactivate_old_paypal_subscription`)
                   .then( result => {

                      if (result.data && !result.data.error)
                        this.$swal({
                          title:'Operation successful!',
                          icon:'success',
                          type:'success',
                          text:result.data.message
                        }).then( () => {
                          location.href = '/myaccount'
                        })
                      else
                        this.$swal({
                          title:'Operation failed',
                          icon:'warning',
                          type:'warning',
                          text:result.data.message
                        })
                      
                   })
            }
          
        })
    },
    build_phrases(string) {
      let data = string.split("_");
      let final_string = '';
      for (let el in data)
        final_string += `${data[el]} `;
      return final_string;
    },
    get_legacy_subscription() {
      axios .get(`${common.supervisorApi}subscriptions/get_legacy_subscription`)
            .then(result => {
              if (result.data && !result.data.error) {

                this.legacy = result.data.data
                this.display = {
                  name:legacyReference[this.legacy.recurring_name]['name'],
                  period:legacyReference[this.legacy.recurring_name]['period']
                }
                //this.legacy.status = this.build_phrases(this.legacy.txn_type);
                this.legacy.date_added_formatted=this.format_date(this.legacy.date_added)
                this.legacy.next_payment_date_formatted=this.format_next_payment_date_paypal(this.legacy.next_payment_date)


              }
            })
    },
    format_next_payment_date_paypal(date_string){
      //initial format 02:00:00 Mar 08, 2024 PST
      const dateArray = date_string.replace(/,/g, "").split(" ")
      const datePreFormatted=[dateArray[2],dateArray[1],dateArray[3]].join(" ")
      const dateObject = Date.parse(datePreFormatted)
      const dateFormatted=new Intl.DateTimeFormat('en-GB',{ dateStyle: 'long'}).format(dateObject)
      return dateFormatted
    },

    format_date(date_string){
      //initial format YYYY-MM-DD HH:MM:SS
      const dateArray = date_string.split(" ") 
      const dateObject = Date.parse(dateArray.shift()) //remove the time
      const dateFormatted=new Intl.DateTimeFormat('en-GB',{ dateStyle: 'long'}).format(dateObject)
      return dateFormatted      
    }

  },
  created() {
    this.get_legacy_subscription()
  }
}
</script>

<style lang="scss">
.legacy-subscription {
  button {
    padding:10px 20px;
    text-transform:uppercase;
    background-color:#277683;
    color:#FFF;
    border:none;
    box-sizing:border-box;
    border-radius:4px;
    -moz-border-radius:4px;
    -webkit-border-radius:4px;
    -ms-border-radius:4px;
    -o-border-radius:4px;
  }
}
</style>
